ul.navigation {
    margin: 0;
    padding: 0;
    list-style: none;

    :is(li) {
        font-size: 1.25rem;
        white-space: nowrap;
        margin-bottom: 1rem;
    }
}

ul.statistics {
    margin: 0;
    padding: 0;
    list-style: none;

    :is(li) {
        font-size: 1.1rem;
        margin-bottom: 0.5rem;
    }
}

ol.checklist {
    padding-left: 1.7rem;

    :is(li) {
        font-size: 1.1rem;
        margin-bottom: 0.5rem;

        &.completed {
            list-style-type: "✅ ";
        }
    }
}
